var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "component-image", class: _vm.computedClass },
    [
      _vm.finishLoad
        ? [
            _vm.type === _vm.TYPES.IMG
              ? _c("img", {
                  staticClass: "inner-image",
                  style: _vm.imgStyle,
                  attrs: { src: _vm.imgSrc }
                })
              : _vm.type === _vm.TYPES.BG
              ? _c("div", { staticClass: "inner-bg", style: _vm.bgStyle })
              : _vm._e()
          ]
        : _c("div", { staticClass: "c-loader" })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }